import { driver, DriveStep } from 'driver.js';
import 'driver.js/dist/driver.css';
import { baseTourConfig, injectTourStyles } from './tourConfig';
import { TourId } from '@/store/tourStore';

export const TOUR_ID: TourId = 'create-league';

export const createSteps = (navigate: (path: string) => void): DriveStep[] => [
  {
    popover: {
      title: 'Create Your First League',
      description: 'A league is a recurring competition that runs for a set period (e.g., Spring 2026, Fall 2026). Let\'s set one up!',
      side: 'over',
      align: 'center',
    },
  },
  {
    element: '[data-tour="nav-organize"]',
    popover: {
      title: 'Go to Competitions',
      description: 'Competitions is where you create and manage all your leagues and tournaments in one place.',
      side: 'right',
      align: 'start',
      onNextClick: (element, step, options) => {
        navigate('/admin/organize');
        setTimeout(() => {
          options.driver.moveNext();
        }, 500);
      },
    },
  },
  {
    element: '[data-tour="organize-add-league"]',
    popover: {
      title: 'Add a League',
      description: 'Click Add League to open the create dialog. Name it (like "Spring 2026"), review the divisions pre-filled from your sport\'s template, and hit Create. Registration opens in the same step unless you uncheck it.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="organize-leagues"]',
    popover: {
      title: 'Your Leagues',
      description: 'Leagues appear here with their divisions. Click Add Division on a league to add more inline, drag teams between divisions, and open the "..." menu for Settings and more.',
      side: 'top',
      align: 'center',
    },
  },
  {
    element: '[data-tour="nav-registration"]',
    popover: {
      title: 'Next Step: Registration',
      description: 'After creating a league, head to Team Registration to set up a registration form so teams can sign up and pay!',
      side: 'right',
      align: 'start',
    },
  },
];

export const startCreateLeagueTour = (onComplete?: () => void, navigate?: (path: string) => void) => {
  injectTourStyles();

  const steps = createSteps(navigate || (() => {}));
  
  const driverObj = driver({
    ...baseTourConfig,
    steps,
    onDestroyStarted: () => {
      onComplete?.();
      driverObj.destroy();
    },
  });

  driverObj.drive();
  return driverObj;
};
